export const getDaysLeft = (endAt) => {
  const now = new Date();
  const end = new Date(endAt);
  if (end < now) {
    return 0;
  }
  const diff = end.getTime() - now.getTime();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
}